import superagent from "superagent";
import Cookies from "universal-cookie";
import { IS_LOADING, THROW_ERROR, THROW_SUCCESS } from "../../../../store/constants";
import { base_url } from "../../../../utils/constants";
import { getRequest } from "../../../../utils/request";
import { GET_HOME_PAGE_DATA } from "../../../home/constants";

const cookie = new Cookies();

export const addHomeDataAction = (data, editView, endPoint) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });
  return (
    superagent
      .post(`${base_url}admin/${endPoint}`)
      .send(data)
      .set("Accept", "application/json")
      // .set("Content-type", "application/json")
      // "Content-type": "application/json",
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        if (res) {
          if (res.body.status) {
            dispatch({ type: THROW_SUCCESS, payload: res.body.message });
            getRequest("get-home-details", null, dispatch, GET_HOME_PAGE_DATA);
            editView(false);
          } else {
            dispatch({ type: THROW_ERROR, payload: res.body.message });
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: err.data.message });
          dispatch({ type: IS_LOADING, payload: false });
        }
      })
  );
};

export const getResources = (data, setResources) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .get(`${base_url}resource`)
    .query(data)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          // getRequest(`home-cms`, null, dispatch, GET_HOME_PAGE_DATA)
          setResources(res.body.data.data);
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err.data.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
};

export const uploadFileAction = (data, fieldValue, name, setUpload, setVideoUploading) => (dispatch) => {
  const form_data = new FormData();
  form_data.append("file", data.file);
  return superagent
    .post(`${base_url}upload-cdn`)
    .send(form_data)
    .on("progress", function (e) {
      setUpload?.(Math.round(e.percent, 0));
      setVideoUploading?.(true);
    })
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          fieldValue(name, res.body.data);
          setVideoUploading?.(false);
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err.data.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
};

export const uploadFileNewAction = (data, fieldValue, name, setLoading) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });
  return (
    superagent
      .post(`${base_url}upload-cdn-new`)
      .send(data)
      // .on("progress", function (e) {
      //   if (setUpload) {
      //     setUpload?.(Math.round(e.percent, 0));
      //   }

      //   setVideoUploading?.(true);
      // })
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        if (res) {
          if (res.body.status) {
            fieldValue(name, res.body.data);
            if (setLoading) {
              setLoading(false);
            }

            // setVideoUploading?.(false);
            dispatch({ type: IS_LOADING, payload: false });
          } else {
            dispatch({ type: THROW_ERROR, payload: res.body.message });
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: err.data.message });
          dispatch({ type: IS_LOADING, payload: false });
        }
      })
  );
};
